import React, { useState, useEffect } from 'react'
import { Input, TextArea, DateTime, InputFile, Button, Radio } from '../DesignSystem'
import { toast } from 'react-toastify'
import moment from 'moment'
import axios from 'axios'
import { toBase64 } from '../../constants/others'
// import { generatePdf } from '../../constants/others/generatePdf'
import blocked_email_providers from '../../constants/blocked_email_providers.txt'

import './index.scss'

const Form = () => {
  const [form, setForm] = useState({
    Email: '',
    NomeCompleto: '',
    Link: '',
    'Data da publicação': moment().format('DD/MM/YYYY'),
    'Print da publicação': null,
    'Breve resumo': '',
    Instagram: false,
    Facebook: false,
    YouTube: false,
    X: false,
    TikTok: false,
  })

  const [loading, setLoading] = useState(false)

  const [emailBlocklist, setEmailBlocklist] = useState([])

  useEffect(() => {
    const getEmailBlockList = async () => {
      let emailBlocklist = await fetch(blocked_email_providers)
      emailBlocklist = await emailBlocklist.text()
      emailBlocklist = emailBlocklist.replace(/(\r)/g, '').split('\n')
      setEmailBlocklist(emailBlocklist)
    }
    getEmailBlockList()
  }, [])

  function changeForm(key, value) {
    if (!loading) {
      let cForm = { ...form }
      for (let i in cForm) {
        if (typeof cForm[i] === 'boolean' && typeof cForm[key] === 'boolean') {
          cForm[i] = false
        }
      }
      cForm[key] = value
      setForm(cForm)
    }
  }

  async function sendReport(event) {
    event.preventDefault()
    setLoading(true)
    //#region Validations

    let optionValidate = false
    for (let i in form) {
      if (typeof form[i] === 'boolean') {
        if (form[i]) {
          optionValidate = true
          break
        }
      }
    }

    let emailValidate = false
    function isEmail(emailAdress) {
      let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

      if (emailAdress.match(regex)) return !emailBlocklist.includes(emailAdress.split('@')[1])
      else return false
    }
    emailValidate = isEmail(form.Email)

    let urlValidate = false
    function isURL(url) {
      const pattern = /^(https?:\/\/)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/
      return pattern.test(url)
    }

    urlValidate = isURL(form.Link)

    if (!urlValidate) {
      toast.warning('Insira uma URL válida')
      setLoading(false)
      return
    }

    if (!emailValidate) {
      toast.warning('Insira um email válido')
      setLoading(false)
      return
    }
    if (!optionValidate) {
      toast.warning('Selecione a rede social')
      setLoading(false)
      return
    }
    //#endregion

    try {
      // function blobToBase64(blob) {
      //   return new Promise((resolve, _) => {
      //     const reader = new FileReader()
      //     reader.onloadend = () => resolve(reader.result)
      //     reader.readAsDataURL(blob)
      //   })
      // }
      const anexos = []

      anexos.push({
        fileName: form['Print da publicação'].name,
        path: await toBase64(form['Print da publicação'].file),
      })
      // const pdfFile = await generatePdf({ form, image: anexos[0].path })
      // let pdf = await blobToBase64(pdfFile)

      // anexos.push({
      //   fileName: 'Documento',
      //   path: pdf,
      // })

      let socialNetwork = ''
      for (let key in form) {
        if (typeof form[key] === 'boolean' && form[key]) {
          socialNetwork = key
        }
      }

      // anexos.push({ pdf: await toBase64(pdf) })
      const data = {
        Email: form.Email,
        'Nome Completo': form.NomeCompleto,
        Link: form.Link,
        'Data da publicação': form['Data da publicação'],
        'Print da publicação': form['Print da publicação'],
        'Breve resumo': form['Breve resumo'],
        Instagram: form.Instagram,
        Facebook: form.Facebook,
        YouTube: form.YouTube,
        X: form.X,
        TikTok: form.TikTok,
        'Rede social': socialNetwork,
        anexos,
      }

      let response = await axios.post('/', { form: data })

      // Form reset
      setForm({
        Email: '',
        NomeCompleto: '',
        Link: '',
        'Data da publicação': moment().format('DD/MM/YYYY'),
        'Print da publicação': null,
        'Breve resumo': '',
        Instagram: false,
        Facebook: false,
        YouTube: false,
        X: false,
        TikTok: false,
      })
      setLoading(false)
      toast.success('Formulário enviado com sucesso')
    } catch (error) {
      setLoading(false)
      toast.error('Erro interno do servidor')
      console.log(error)
    }
  }

  return (
    <form onSubmit={sendReport} className='form'>
      <fieldset disabled={loading}>
        <h1>Por favor, preencha todos os campos:</h1>

        <div className='inputs__container'>
          <p>Informe o seu nome completo</p>
          <Input
            required
            placeholder='Informe o seu nome completo'
            label='Nome completo'
            value={form.NomeCompleto}
            onChange={value => changeForm('NomeCompleto', value)}
          />
        </div>

        <div className='inputs__container'>
          <p>Insira o seu endereço de email</p>
          <Input
            required
            placeholder='Insira o seu endereço de email'
            label='Email'
            value={form.Email}
            onChange={value => changeForm('Email', value)}
          />
        </div>

        <div className='options__container'>
          <p>Em qual rede social você visualizou a publicação</p>
          <div onClick={() => changeForm('Facebook', !form['Facebook'])}>
            <Radio value={form.Facebook} />
            <label>Facebook</label>
          </div>

          <div onClick={() => changeForm('Instagram', !form['Instagram'])}>
            <Radio value={form.Instagram} />
            <label>Instagram</label>
          </div>

          <div onClick={() => changeForm('TikTok', !form['TikTok'])}>
            <Radio value={form.TikTok} />
            <label>Tiktok</label>
          </div>

          <div onClick={() => changeForm('X', !form['X'])}>
            <Radio value={form.X} />
            <label>X</label>
          </div>

          <div onClick={() => changeForm('YouTube', !form['YouTube'])}>
            <Radio value={form.YouTube} />
            <label>YouTube</label>
          </div>
        </div>

        <div className='inputs__container'>
          <p>Insira a data da publicação</p>
          <DateTime
            required
            label='Data da publicação'
            value={form['Data da publicação']}
            onChange={value => changeForm('Data da publicação', value)}
            disabled={loading}
          />
        </div>

        <div className='inputs__container'>
          <p>Endereço da publicação</p>
          <Input
            required
            placeholder='Cole o endereço da publicação aqui'
            label='URL'
            value={form.Link}
            onChange={value => changeForm('Link', value)}
          />
        </div>

        <div className='inputs__container'>
          <p>Imagem da publicação</p>
          <InputFile
            accept='image/*'
            placeholder='Imagem'
            label={null}
            value={form['Print da publicação']}
            onChange={value => changeForm('Print da publicação', value)}
            required={true}
          />
        </div>

        <div className='inputs__container'>
          <p>Escreva um breve resumo da conduta antissemita</p>
          <TextArea
            required
            placeholder='Escreva o seu texto aqui'
            label='Breve resumo'
            value={form['Breve resumo']}
            onChange={value => changeForm('Breve resumo', value)}
            hasLabel
          />
        </div>
        <Button contained fullWidth textUppercase loading={loading} disabled={loading}>
          Enviar
        </Button>
      </fieldset>
    </form>
  )
}

export default Form
